/*
 * AUD-016 fix (2026-08-04): the mobile search box was a dead tap target.
 * ECXHeader.bindEventHandlers() in theme.js binds the click handler with
 * this.$(".js-search-open-trigger") — querySelector, singular — so only the
 * FIRST trigger gets a listener. header.liquid renders three of them, and the
 * first is the desktop icon (display:none on mobile); the visible mobile
 * full-width box is the second and got no listener. Its inline
 * onclick="event.preventDefault()" also suppressed the /search navigation
 * fallback, so tapping it did nothing at all — silently.
 *
 * This binds the header's existing openPredictiveSearch method to the
 * remaining triggers. It does not reimplement search.
 * Loaded after theme.js in layout/theme.liquid; safe to remove once theme.js
 * uses querySelectorAll upstream.
 */
(function () {
  var BOUND_ATTR = "data-aud016-bound";

  function bindHeader(header) {
    if (!header || typeof header.openPredictiveSearch !== "function") return;

    var triggers = header.querySelectorAll(".js-search-open-trigger");

    for (var i = 0; i < triggers.length; i++) {
      var trigger = triggers[i];

      // Skip the one theme.js already bound, and anything we bound earlier.
      if (trigger === header.searchHeaderOpenBtn) continue;
      if (trigger.hasAttribute(BOUND_ATTR)) continue;

      trigger.setAttribute(BOUND_ATTR, "");
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        header.openPredictiveSearch(event);
      });
    }
  }

  function bindAll() {
    var headers = document.querySelectorAll("ecx-header");
    for (var i = 0; i < headers.length; i++) bindHeader(headers[i]);
  }

  function start() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined("ecx-header").then(bindAll);
    } else {
      bindAll();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  // Theme editor re-renders the header section without a page reload.
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector) start();
  });
})();
